import { useEffect, useState } from 'react';

import type { ArchitectureStatus } from '../../application/dto/ArchitectureStatus';
import type { BuildInfo } from '../../application/dto/BuildInfo';

interface ArchitecturePageProps {
  readonly loadStatuses: () => Promise<readonly ArchitectureStatus[]>;
  readonly buildInfo: BuildInfo;
}

export function ArchitecturePage({ loadStatuses, buildInfo }: ArchitecturePageProps) {
  const [statuses, setStatuses] = useState<readonly ArchitectureStatus[]>([]);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    void loadStatuses()
      .then((loadedStatuses) => {
        if (active) setStatuses(loadedStatuses);
      })
      .catch(() => {
        if (active) setFailed(true);
      });
    return () => {
      active = false;
    };
  }, [loadStatuses]);

  return (
    <main className="page architecture-shell">
      <section className="architecture-panel" aria-labelledby="architecture-title">
        <p className="architecture-shell__eyebrow">Temporary technical diagnostic</p>
        <h1 id="architecture-title">Architecture layers</h1>
        {failed ? <p role="status">Persistence diagnostic unavailable</p> : null}
        <ul>
          {statuses.map((status) => (
            <li key={status.label}>
              <span aria-hidden="true">{status.available ? 'OK' : 'Unavailable'}</span>{' '}
              {status.label}
            </li>
          ))}
        </ul>
        <h2 className="architecture-shell__eyebrow">Build</h2>
        <dl className="build-info">
          <div>
            <dt>Application version</dt>
            <dd>{buildInfo.appVersion}</dd>
          </div>
          <div>
            <dt>Git commit</dt>
            <dd>{buildInfo.gitCommit}</dd>
          </div>
          <div>
            <dt>Branch</dt>
            <dd>{buildInfo.gitBranch}</dd>
          </div>
          <div>
            <dt>Build date</dt>
            <dd>{buildInfo.buildDate}</dd>
          </div>
          <div>
            <dt>Environment</dt>
            <dd>{buildInfo.environment}</dd>
          </div>
        </dl>
      </section>
    </main>
  );
}
